export const communicationMasterEndpoints = (builder) => ({
  getCommunicationTemplates: builder.query({
    query: (args = {}) => {
      const { communication_code = null, is_active = null, pageNumber = null, pageSize = null } = args;

      const params = {};
      if (communication_code !== null && communication_code !== undefined) {
        params.communication_code = communication_code;
      }
      if (is_active !== null && is_active !== undefined) {
        params.is_active = is_active;
      }
      if (pageNumber !== null && pageNumber !== undefined) {
        params.pageNumber = pageNumber;
      }
      if (pageSize !== null && pageSize !== undefined) {
        params.pageSize = pageSize;
      }

      return {
        url: '/admin/communication-templates',
        method: 'GET',
        params,
      };
    },
    transformResponse: (response) => ({
      data: response?.data ?? [],
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: (result) => {
      const rows = result && Array.isArray(result.data) ? result.data : [];
      if (!rows.length) return [{ type: 'CommunicationTemplate', id: 'LIST' }];

      return [
        ...rows.map((row) => ({
          type: 'CommunicationTemplate',
          id:
            row.TemplateID ??
            row.TemplateId ??
            row.TemplateCode ??
            row.CommunicationCode ??
            row.id ??
            'ROW',
        })),
        { type: 'CommunicationTemplate', id: 'LIST' },
      ];
    },
  }),

  getFilteredCustomers: builder.mutation({
    query: (payload) => ({
      url: '/admin/communication-filter-customers',
      method: 'POST',
      body: payload,
    }),
  }),

  sendCommunication: builder.mutation({
    query: (payload) => ({
      url: '/admin/communication-send',
      method: 'POST',
      body: payload,
    }),
  }),

  sendPremiumCommunication: builder.mutation({
    query: (payload) => ({
      url: '/admin/communication-send-premium',
      method: 'POST',
      body: payload,
    }),
  }),

  getBatchStatus: builder.query({
    query: (batchId) => `/admin/batch-status/${batchId}`,
  }),
  saveCommunicationSchedule: builder.mutation({
    query: (payload) => ({
      url: '/admin/communication-schedule',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['CommunicationSchedule'],
  }),
  getCommunicationSchedule: builder.query({
    query: () => '/admin/get-communication-schedule',
    providesTags: ['CommunicationSchedule'],
  }),
  deleteCommunicationSchedule: builder.mutation({
    query: (payload) => ({
      url: '/admin/delete-schedule',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: ['CommunicationSchedule'],
  }),

  saveAllScheduleApi: builder.mutation({
    query: (data) => ({
      url: "/admin/save-all-communication-schedules",
      method: "POST",
      body: data
    }),
    invalidatesTags: ['CommunicationSchedule'],
  }),
  
  getCommunicationLogs: builder.query({
    query: (params) => ({
      url: '/admin/communication-logs',
      method: 'GET',
      params: {
        fromDate: params?.fromDate,
        toDate: params?.toDate,
        channel: params?.channel,
        page: params?.page,
        pageSize: params?.pageSize,
      },
    }),
    transformResponse: (response) => ({
      data: response?.data ?? [],
      credits: response?.credits ?? [], // this line for credits
      success: !!response?.success,
      totalCount: response?.totalCount ?? 0,
    }),
  }),

  sendComparisonReportPdf: builder.mutation({
    query: (payload) => ({
      url: '/common/send-comparison-pdf',
      method: 'POST',
      body: payload,
    }),
  }),
});
